import React from 'react';
import glamorous from 'glamorous';
import RecallsList from './results-list';
import SideBar from './side-bar';
import SearchBar from './search-bar';

export default (props) => (
  <div>
    <SearchBar {...props} />
    <glamorous.Div className="container-fluid" css={{ marginTop: 15 }}>
      <div className="row">
        <SideBar {...props} />
        <RecallsList {...props} className="recalls-list"/>
      </div>
    </glamorous.Div>
  </div>
);



// WEBPACK FOOTER //
// ./src/views/recalls-list/index.js